import styled from 'styled-components';

export const Crop_Layout = styled.div`
  display: flex;
  flex-direction: column;
  height: 100vh;
  position: fixed;
`;

export const Crop_Container = styled.div`
  flex: 1;
  position: relative;
  background: #000;
`;
